module.exports = __webpack_public_path__ + "assets/34061ef8275d18fd421ac20927c7bdbc.png";